import INVENTORY_API_BASE_URL from "../../config/api";
import { apiFetch } from "../../config/apiClient";






















  
  
  
  











































  
  
  
  
























import { useState, useEffect } from "react";
import "./ManageReturnInbound.css";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

function ManageReturnInbound() {
  const [fullData, setFullData] = useState([]);
  const [managerReturnData, setManagerReturnData] = useState([]);
  const [distributorOptions, setDistributorOptions] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState("All");
  const [selectedGRN, setSelectedGRN] = useState("All");
  const [selectedSKU, setSelectedSKU] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [postedItems, setPostedItems] = useState({});

  const itemsPerPage = 50;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [inboundRes, managerRes] = await Promise.all([
          Axios.get(`${INVENTORY_API_BASE_URL}/getReturnInbound`),
          Axios.get(`${INVENTORY_API_BASE_URL}/getManagereturn`),
        ]);

        const sortedInbound = inboundRes.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );

        setFullData(sortedInbound);
        setManagerReturnData(managerRes.data);

        const distributors = [
          "All",
          ...new Set(managerRes.data.map((item) => item.Distributor)),
        ];
        setDistributorOptions(distributors);
        setCurrentPage(1);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

const handlePost = async (grnNo, sku) => {
  try {
    const response = await apiFetch(`${INVENTORY_API_BASE_URL}/api/return/purchase-summary`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        grnNo: grnNo,   
        sku: sku
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("Full error response:", data);
      return;
    }

    console.log("API Response:", data);

  } catch (error) {
    console.error("Network error:", error);
  }
};

  const getDistributor = (grnNo) => {
    const match = managerReturnData.find(
      (item) => String(item.OrderSeq) === String(grnNo)
    );
    return match ? match.Distributor : "N/A";
  };

  const filteredData = fullData.filter((item) => {
    const matchDistributor =
      selectedDistributor === "All" ||
      getDistributor(item.grnNo) === selectedDistributor;

    const matchGRN =
      selectedGRN === "All" || String(item.grnNo) === String(selectedGRN);

    const matchSKU =
      selectedSKU.trim() === "" ||
      String(item.sku).includes(selectedSKU.trim());

    return matchDistributor && matchGRN && matchSKU;
  });

  const groupedMap = {};

 filteredData.forEach((item) => {
  const key = `${item.grnNo}-${item.sku}`;

  if (!groupedMap[key]) {
    groupedMap[key] = {
      grnNo: item.grnNo,
      sku: item.sku,
      Title: item.Title,
      date: item.date,
      barcodeData: item.barcodeData || [],
      count: item.count || 0,
    };
  } else {
    groupedMap[key].count += item.count || 0;
    groupedMap[key].barcodeData = [
      ...groupedMap[key].barcodeData,
      ...(item.barcodeData || []),
    ];
    if (new Date(item.date) > new Date(groupedMap[key].date)) {
      groupedMap[key].date = item.date;
      groupedMap[key].Title = item.Title;
    }
  }
});

  managerReturnData.forEach((item) => {
    const grn = item.OrderSeq;
    const matchDistributor =
      selectedDistributor === "All" || item.Distributor === selectedDistributor;
    const matchGRN =
      selectedGRN === "All" || String(grn) === String(selectedGRN);

    if (matchDistributor && matchGRN) {
      item.Entries.forEach((entry) => {
        const skuMatch =
          selectedSKU.trim() === "" ||
          String(entry.SKU).includes(selectedSKU.trim());

        const key = `${grn}-${entry.SKU}`;
        if (skuMatch && !groupedMap[key]) {
          groupedMap[key] = {
            grnNo: grn,
            sku: entry.SKU,
            Title: entry.Title || "",
            date: item.date || "",
            count: 0,
          };
        }
      });
    }
  });

  const groupedData = Object.values(groupedMap);

  const paginatedGroupedData = groupedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(groupedData.length / itemsPerPage);

  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const exportToCSV = () => {
    const headers = [
      "GRN_Number",
      "Distributor Name",
      "Return Inbound Quantity",
      "Return GRN Quantity",
      "SKU",
      "Title",
      "Dated",
    ];
  
    const rows = groupedData.map((row) => {
      const returnQuantity = getReturnQuantityByGRNAndSKU(row.grnNo, row.sku);
      return [
        row.grnNo,
        getDistributor(row.grnNo),
        row.count,
        returnQuantity,
        row.sku,
        row.Title,
        row.date,
      ];
    });
  
    let csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((e) => e.join(","))].join("\n");
  
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "return_inbound_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const distributorFilteredData = fullData.filter((item) =>
    selectedDistributor === "All"
      ? true
      : getDistributor(item.grnNo) === selectedDistributor
  );

  const totalSkuCount = distributorFilteredData.reduce(
    (sum, item) => sum + item.count,
    0
  );

  const filteredReturnData =
    selectedDistributor === "All"
      ? managerReturnData
      : managerReturnData.filter(
          (item) => item.Distributor === selectedDistributor
        );

  const totalQuantity = filteredReturnData.reduce(
    (sum, item) => sum + (item.totalquantity || 0),
    0
  );

  const getReturnQuantityByGRNAndSKU = (grnNo, sku) => {
    return managerReturnData
      .filter((item) => String(item.OrderSeq) === String(grnNo))
      .flatMap((item) => item.Entries)
      .filter((entry) => String(entry.SKU) === String(sku))
      .reduce((sum, entry) => sum + (entry.Return_Quantity || 0), 0);
  };

  return (
    <main className="manage-return-inbound">
      <div className="manage-return-inbound__content">
        <header className="manage-return-inbound__header">
          <div>
            <p className="manage-return-inbound__eyebrow">Returns operations</p>
            <h1>Manage return inbound</h1>
            <p className="manage-return-inbound__subtitle">
              Reconcile received return items against their return GRNs.
            </p>
          </div>
          <div className="manage-return-inbound__header-meta">
            <span className="manage-return-inbound__live-dot" aria-hidden="true" />
            <span>Inbound reconciliation</span>
          </div>
        </header>

        <section className="manage-return-inbound__stats" aria-label="Return inbound summary">
          <article className="manage-return-inbound__stat-card">
            <span className="manage-return-inbound__stat-label">Inbound SKU units</span>
            <strong>{Number(totalSkuCount || 0).toLocaleString()}</strong>
            <span className="manage-return-inbound__stat-note">For the selected distributor</span>
          </article>
          <article className="manage-return-inbound__stat-card manage-return-inbound__stat-card--accent">
            <span className="manage-return-inbound__stat-label">Return GRN quantity</span>
            <strong>{Number(totalQuantity || 0).toLocaleString()}</strong>
            <span className="manage-return-inbound__stat-note">Recorded return quantity</span>
          </article>
          <article className="manage-return-inbound__stat-card">
            <span className="manage-return-inbound__stat-label">Matching line items</span>
            <strong>{groupedData.length.toLocaleString()}</strong>
            <span className="manage-return-inbound__stat-note">Across the active filters</span>
          </article>
        </section>

        <section className="manage-return-inbound__filters" aria-label="Filter return inbound">
          <div className="manage-return-inbound__filters-heading">
            <div>
              <h2>Find return items</h2>
              <p>Filter the inbound register by distributor, GRN, or SKU.</p>
            </div>
            <button
              type="button"
              className="manage-return-inbound__export"
              onClick={exportToCSV}
            >
              <span aria-hidden="true">↓</span>
              Download CSV
            </button>
          </div>

          <div className="manage-return-inbound__filter-grid">
            <div className="manage-return-inbound__field manage-return-inbound__field--wide">
              <label htmlFor="distributorFilter">Distributor</label>
              <select
                id="distributorFilter"
                value={selectedDistributor}
                onChange={(e) => {
                  setSelectedDistributor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                {distributorOptions.map((dist, idx) => (
                  <option key={idx} value={dist}>{dist}</option>
                ))}
              </select>
            </div>

            <div className="manage-return-inbound__field">
              <label htmlFor="grnFilter">Return GRN</label>
              <select
                id="grnFilter"
                value={selectedGRN}
                onChange={(e) => {
                  setSelectedGRN(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="All">All GRNs</option>
                {[
                  ...new Set(
                    fullData
                      .filter((item) =>
                        selectedDistributor === "All"
                          ? true
                          : getDistributor(item.grnNo) === selectedDistributor
                      )
                      .map((item) => item.grnNo)
                  ),
                ].map((grn, idx) => (
                  <option key={idx} value={grn}>{grn}</option>
                ))}
              </select>
            </div>

            <div className="manage-return-inbound__field">
              <label htmlFor="skuFilter">SKU</label>
              <input
                id="skuFilter"
                type="text"
                placeholder="Search SKU"
                value={selectedSKU}
                onChange={(e) => {
                  setSelectedSKU(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          {selectedGRN !== "All" && (
            <div className="manage-return-inbound__grn-summary">
              <span className="manage-return-inbound__summary-mark" aria-hidden="true">↳</span>
              <span>
                Return inbound for GRN <strong>{selectedGRN}</strong>
              </span>
              <strong className="manage-return-inbound__summary-value">
                {
                  Object.values(
                    filteredData
                      .filter((item) => String(item.grnNo) === String(selectedGRN))
                      .reduce((acc, item) => {
                        const key = item.grnNo + "-" + item.sku;
                        if (!acc[key]) {
                          acc[key] = item.barcodeData?.length || 0;
                        } else {
                          acc[key] += item.barcodeData?.length || 0;
                        }
                        return acc;
                      }, {})
                  ).reduce((sum, val) => sum + val, 0)
                } units
              </strong>
            </div>
          )}
        </section>

        <section className="manage-return-inbound__table-panel" aria-label="Return inbound records">
          <div className="manage-return-inbound__table-heading">
            <div>
              <h2>Inbound reconciliation</h2>
              <p>Received scan quantity compared with the return GRN quantity.</p>
            </div>
            <span className="manage-return-inbound__record-count">
              {groupedData.length.toLocaleString()} records
            </span>
          </div>

          <div className="manage-return-inbound__table-wrap">
            <Table hover className="manage-return-inbound__table">
              <thead>
                <tr>
                  <th scope="col">GRN number</th>
                  <th scope="col">Distributor</th>
                  <th scope="col">Received qty.</th>
                  <th scope="col">GRN qty.</th>
                  <th scope="col">SKU</th>
                  <th scope="col">Title</th>
                  <th scope="col">Date received</th>
                </tr>
              </thead>
              <tbody>
                {paginatedGroupedData.length === 0 ? (
                  <tr>
                    <td className="manage-return-inbound__empty" colSpan={7}>
                      <span className="manage-return-inbound__empty-icon" aria-hidden="true">⌕</span>
                      <strong>No return items found</strong>
                      <span>Try changing or clearing one of the filters.</span>
                    </td>
                  </tr>
                ) : (
                  paginatedGroupedData.map((row, index) => {
                    const returnQuantity = getReturnQuantityByGRNAndSKU(row.grnNo, row.sku);
                    const key = row.grnNo + "-" + row.sku;
                    const isMatched = row.barcodeData?.length === returnQuantity;

                    if (isMatched && !postedItems[key]) {
                      handlePost(row.grnNo, row.sku);
                      setPostedItems((prev) => ({ ...prev, [key]: true }));
                    }

                    return (
                      <tr key={key + "-" + index}>
                        <td className="manage-return-inbound__grn-cell">{row.grnNo}</td>
                        <td>{getDistributor(row.grnNo)}</td>
                        <td>
                          <span className={"manage-return-inbound__quantity " + (isMatched ? "is-matched" : "is-pending")}>
                            {row.barcodeData?.length || 0}
                          </span>
                        </td>
                        <td>{returnQuantity}</td>
                        <td className="manage-return-inbound__sku-cell">{row.sku}</td>
                        <td className="manage-return-inbound__title-cell" title={row.Title || ""}>{row.Title}</td>
                        <td>
                          {row.date
                            ? row.date.slice(0, 10).split("-").reverse().join("/")
                            : "—"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>

          <footer className="manage-return-inbound__table-footer">
            <p>
              Showing{" "}
              <strong>
                {groupedData.length === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1}
                {"–"}
                {Math.min(currentPage * itemsPerPage, groupedData.length)}
              </strong>
              {" "}of <strong>{groupedData.length}</strong> line items
            </p>
            <div className="manage-return-inbound__pagination" aria-label="Pagination">
              <button
                type="button"
                onClick={goToPreviousPage}
                disabled={currentPage === 1}
                aria-label="Go to previous page"
              >
                ← Previous
              </button>
              <span>Page <strong>{currentPage}</strong> of <strong>{Math.max(totalPages, 1)}</strong></span>
              <button
                type="button"
                onClick={goToNextPage}
                disabled={currentPage >= Math.max(totalPages, 1)}
                aria-label="Go to next page"
              >
                Next →
              </button>
            </div>
          </footer>
        </section>
      </div>
    </main>
  );
}

export default ManageReturnInbound;
